<template>
  <div class="errors-modal-card modal-card" style="width: auto">
    <section class="modal-card-body">
      <div class="pagination-wrapper">
        <div class="pagination-header">
          <b-button
            v-show="showPreviousButton"
            @click="
              pageIndex = pageIndex - 1;
              loadByRegion();
            "
            >Previous</b-button
          >
          <b-button
            class="apply-filter"
            v-show="showFirstButton"
            @click="
              pageIndex = 1;
              loadByRegion();
            "
            >First</b-button
          >
          <span class="page-index"
            >{{ minPageIndex }} to {{ maxPageIndex }} of
            {{ totalResults }}</span
          >
          <b-button
            v-show="showLastButton"
            @click="
              pageIndex = totalPages;
              loadByRegion();
            "
            >Last</b-button
          >
          <b-button
            class="apply-filter"
            v-show="showNextButton"
            @click="
              pageIndex = pageIndex + 1;
              loadByRegion();
            "
            >Next</b-button
          >
          <span class="page-navigator" v-show="totalResults > 10"
            ><span class="show-text">Show</span
            ><b-select
              class="page-display-number"
              v-model="numberOfItemsPerPage"
              @input="
                pageIndex = Math.floor(minPageIndex / numberOfItemsPerPage) + 1;
                loadByRegion();
              "
              ><option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </b-select></span
          >
        </div>
      </div>
      <b-table
        :data="validationErrorData"
        :columns="validationEuErrorColumns"
        v-show="region === 'eu'"
      >
      </b-table>
      <b-table
        :data="validationErrorData"
        :columns="validationErrorColumns"
        v-show="region === 'us'"
      >
      </b-table>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Close
      </button>
    </footer>
  </div>
</template>

<script>
export default {
  name: "viewUploadErrorsModal",
  props: ["submissionId", "tab", "region"],
  data() {
    return {
      validationErrorData: [],
      validationErrorColumns: [
        { field: "fieldName", label: "Error Field" },
        { field: "errorDesc", label: "Error Description" },
        { field: "vcat", label: "Supplier Catalog Number" }
      ],
      validationEuErrorColumns: [
        { field: "fieldName", label: "Error Field" },
        { field: "errorDesc", label: "Error Description" },
        { field: "suppItemNbr", label: "Supplier Item Number" }
      ],
      pageIndex: 1,
      minPageIndex: "",
      maxPageIndex: "",
      totalResults: "",
      totalPages: "",
      showPreviousButton: true,
      showNextButton: true,
      showFirstButton: true,
      showLastButton: true,
      numberOfItemsPerPage: 10
    };
  },
  mounted() {
    this.loadByRegion();
  },
  methods: {
    loadByRegion() {
      if (this.region === "eu") {
        this.loadEUValidationErrorData();
      } else {
        this.loadValidationErrorData();
      }
    },
    loadEUValidationErrorData() {
      var modalScope = this;
      var errorTab = "";
      switch (modalScope.tab) {
        case "GI":
          errorTab = "generalInfo";
          break;
        case "PI":
          errorTab = "priceInfo";
          break;
        case "RIPT":
          errorTab = "riProdInfo";
          break;
        case "RICB":
          errorTab = "chemicalInfo";
          break;
        case "RIEI":
          errorTab = "riEquipmentInfo";
          break;
      }
      modalScope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}eu/${errorTab}/Errors?nbrNewItemCrKey=${modalScope.submissionId}&pageNbr=${modalScope.pageIndex}&pageSize=${modalScope.numberOfItemsPerPage}`
        )
        .then(function(response) {
          response.data.startIndex
            ? (modalScope.minPageIndex = response.data.startIndex)
            : (modalScope.minPageIndex = 0);
          response.data.endIndex
            ? (modalScope.maxPageIndex = response.data.endIndex)
            : (modalScope.maxPageIndex = 0);
          response.data.totalCount
            ? (modalScope.totalResults = response.data.totalCount)
            : (modalScope.totalResults = 0);
          response.data.totalPages !== undefined
            ? (modalScope.totalPages = response.data.totalPages)
            : (modalScope.totalPages = 0);
          if (response.data.startIndex <= 1) {
            modalScope.showPreviousButton = false;
            modalScope.showFirstButton = false;
          } else {
            modalScope.showPreviousButton = true;
            modalScope.showFirstButton = true;
          }
          if (modalScope.pageIndex >= modalScope.totalPages) {
            modalScope.showNextButton = false;
            modalScope.showLastButton = false;
          } else {
            modalScope.showNextButton = true;
            modalScope.showLastButton = true;
          }
          modalScope.validationErrorData = response.data.validationsDTOs;
        })
        .catch(function(error) {
          modalScope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to load data. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            queue: false
          });
        });
    },
    loadValidationErrorData() {
      var modalScope = this;
      var errorTab = "";
      switch (modalScope.tab) {
        case "GI":
          errorTab = "generalInfoErrors";
          break;
        case "RI":
          errorTab = "regltryErrors";
          break;
        case "PM":
          errorTab = "portfolioManagementErrors";
          break;
        case "RA":
          errorTab = "regulatoryAffairsErrors";
          break;
        case "PS":
          errorTab = "productServiceErrors";
          break;
      }
      modalScope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}${errorTab}/submissionId/${modalScope.submissionId}?pageNbr=${modalScope.pageIndex}&pageSize=${modalScope.numberOfItemsPerPage}`
        )
        .then(function(response) {
          response.data.startIndex
            ? (modalScope.minPageIndex = response.data.startIndex)
            : (modalScope.minPageIndex = 0);
          response.data.endIndex
            ? (modalScope.maxPageIndex = response.data.endIndex)
            : (modalScope.maxPageIndex = 0);
          response.data.totalCount
            ? (modalScope.totalResults = response.data.totalCount)
            : (modalScope.totalResults = 0);
          response.data.totalPages !== undefined
            ? (modalScope.totalPages = response.data.totalPages)
            : (modalScope.totalPages = 0);
          if (response.data.startIndex <= 1) {
            modalScope.showPreviousButton = false;
            modalScope.showFirstButton = false;
          } else {
            modalScope.showPreviousButton = true;
            modalScope.showFirstButton = true;
          }
          if (modalScope.pageIndex >= modalScope.totalPages) {
            modalScope.showNextButton = false;
            modalScope.showLastButton = false;
          } else {
            modalScope.showNextButton = true;
            modalScope.showLastButton = true;
          }
          modalScope.validationErrorData = response.data.validationsDTOs;
        })
        .catch(function(error) {
          modalScope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to load data. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            queue: false
          });
        });
    }
  }
};
</script>

<style scoped></style>
